import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "41",
  fill: "none",
  viewBox: "0 0 45 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#C2E0FF",
  d: "M25 0c2.734 0 5 2.266 5 5v10.547c-5.781 1.64-10 6.953-10 13.203A13.83 13.83 0 0 0 25.703 40H5c-2.812 0-5-2.187-5-5V5c0-2.734 2.188-5 5-5zM6.25 10C5.547 10 5 10.625 5 11.25c0 .703.547 1.25 1.25 1.25h17.5c.625 0 1.25-.547 1.25-1.25 0-.625-.625-1.25-1.25-1.25zm0 10h12.5c.625 0 1.25-.547 1.25-1.25 0-.625-.625-1.25-1.25-1.25H6.25c-.703 0-1.25.625-1.25 1.25 0 .703.547 1.25 1.25 1.25m0 7.5h7.5c.625 0 1.25-.547 1.25-1.25 0-.625-.625-1.25-1.25-1.25h-7.5C5.547 25 5 25.625 5 26.25c0 .703.547 1.25 1.25 1.25"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0F85FA",
  d: "M22.5 28.75c0-6.172 5-11.25 11.25-11.25C39.922 17.5 45 22.578 45 28.75 45 35 39.922 40 33.75 40 27.5 40 22.5 35 22.5 28.75m16.484-1.562c.47-.47.47-1.329 0-1.797-.468-.47-1.328-.47-1.797 0L32.5 30.156l-2.266-2.265c-.468-.47-1.328-.47-1.797 0-.468.468-.468 1.328 0 1.797l3.125 3.125c.47.468 1.329.468 1.797 0z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }